export default {"src":"/_next/static/image/public/images/components/EmptyResultsCards.339dfc3ad78ffcc96081d7fc59676478.svg","height":210,"width":613};